import { VARIANT_A, VARIANT_B } from '../../experiments/experimentDefaults';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { FlowManager } from '../../flow-management/FlowManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const BranchSplitNameStep122 = {
  name: 'BranchSplitNameStep122',
  stateCheck: state => getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ122, [VARIANT_A, VARIANT_B]),
  rebuildFlow: (flow, state, dispatch) => {
    const nextSteps = FlowManager.pushNextAndRemove([Step.EmailOnlyLandingPage, Step.Name], [Step.LandingPage])(flow);
    const preVerificationSteps = [Step.EmailOnlyLandingPage, Step.Name, Step.Industry, Step.JobRole, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.CodeVerification];
    dispatch(setFlow(nextSteps, preVerificationSteps, getFlowSteps().postVerification, getFlowSteps().postAccountCreation, getFlowSteps().postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};